/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-style[_ngcontent-%COMP%]{width:75%!important}.mat-form-field[_ngcontent-%COMP%]{width:100%!important}.add-partner-header[_ngcontent-%COMP%]{background-color:#d8d8d8;padding:15px 0 15px 15px}.input-names[_ngcontent-%COMP%]{text-align:center;margin:12%}"];
export { styles as styles };
